module.exports = __webpack_public_path__ + "img/belvizelvezetes_tervezes_es_kiviteles_pop_up.31813abb.png";